import React from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingWizard from '../components/OnboardingWizard';

export default function OnboardingPage() {
  const navigate = useNavigate();
  return (
    <div style={{ background: '#080808', minHeight: '100vh' }}>
      <OnboardingWizard onComplete={() => navigate('/dashboard')} />
    </div>
  );
}
